import styled from 'styled-components';
import React from 'react';

export const CardsContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 24px; 
  margin-bottom: 32px;
`;

export const CardContainer = styled.div`
  background: #F6F8FA;
  border-radius: 4px;
  padding: 20px;
  position: relative;
  flex-grow: 1;
`;

export const CardTitleContainer = styled.div<{ justifyContent?: string }>`
  display: flex;  
  gap: 8px;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
`;

export const CardTitle = styled.div`
  color: #686C8B;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 20px;
`;

export const CardTitleLine = ({ color }: { color: string }) => (
  <svg width="4" height="14" viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 1.5L2 12.5" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const CardText = styled.p`
  color: #0A0A0A;
  font-family: ${(props) => props.theme.fonts.grotesk};
  font-size: 32px;
  font-weight: 500;
  line-height: 120%;
`;